import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { BarBaseInputCellEditor } from '../bar-base-input-cell-editor';
import { IBarInputCellEditorParams } from './bar-input-cell-editor-params.contract';

@Component({
    selector: 'bar-input-cell-editor',
    templateUrl: './bar-input-cell-editor.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule]
})
/** @deprecated Use native input cell editor. AG grid editor for regular input fields. */
export class BarInputCellEditor extends BarBaseInputCellEditor<IBarInputCellEditorParams> {
    getValue() {
        let value = super.getValue() as string;

        if (this.params.autoTrim && value) {
            value = value.trim();
            this.formControl.setValue(value);
        }

        return value;
    }
}
